var _rect, _polygon, _g, _polygon2, _polygon3, _g2, _polygon4, _g3, _polygon5, _polygon6, _g4, _polygon7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "3000px",
    height: "1999.992px",
    viewBox: "500 499.98 3000 1999.992",
    enableBackground: "new 500 499.98 3000 1999.992",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 499.998,
    fill: "#F0F0F0",
    width: 3000,
    height: 2000.021
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D80027",
    points: "2187.5,499.98 1812.5,499.98 1812.5,1312.477 500,1312.477 500,1687.477 1812.5,1687.477  1812.5,2499.973 2187.5,2499.973 2187.5,1687.477 3500,1687.477 3500,1312.477 2187.5,1312.477 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "2807.334,1847.801 3500,2232.621 3500,1847.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "2326.086,1847.801 3500,2499.973 3500,2315.555 2658.049,1847.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "3187.309,2499.973 2326.086,2021.473 2326.086,2499.973  "
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "2326.086,1847.801 3500,2499.973 3500,2315.555 2658.049,1847.801 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D80027",
    points: "2326.086,1847.801 3500,2499.973 3500,2315.555 2658.049,1847.801 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "1029.342,1847.789 500,2141.871 500,1847.789  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "1673.914,1930.723 1673.914,2499.967 649.361,2499.967  "
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D80027",
    points: "1341.951,1847.801 500,2315.555 500,2499.973 500,2499.973 1673.914,1847.801 "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "1192.666,1152.152 500,767.332 500,1152.152  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "1673.914,1152.152 500,499.98 500,684.398 1341.951,1152.152  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "812.691,499.98 1673.914,978.48 1673.914,499.98  "
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "1673.914,1152.152 500,499.98 500,684.398 1341.951,1152.152 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D80027",
    points: "1673.914,1152.152 500,499.98 500,684.398 1341.951,1152.152 "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "2970.658,1152.164 3500,858.082 3500,1152.164  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "2326.086,1069.23 2326.086,499.986 3350.639,499.986  "
  }))), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D80027",
    points: "2658.049,1152.152 3500,684.398 3500,499.98 3500,499.98 2326.086,1152.152 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.a451996103ada62826319c06108dac73.svg";
export { ForwardRef as ReactComponent };